export default __webpack_public_path__ + "static/media/14.72f183dd.jpg";